<template>
  <header class="portal-page-heading">
    <div>
      <span v-if="eyebrow" class="eyebrow">{{ eyebrow }}</span>
      <h1>{{ title }}</h1>
      <p v-if="description">{{ description }}</p>
    </div>
    <div v-if="$slots.actions" class="portal-page-heading__actions">
      <slot name="actions" />
    </div>
  </header>
</template>

<script>
export default {
  name: 'PortalPageHeader',
  props: {
    eyebrow: { type: String, default: '' },
    title: { type: String, required: true },
    description: { type: String, default: '' },
  },
};
</script>
